import React from "react";
import { isEmpty } from "lodash";
import { usDateFormat } from "../../../../utils";
import { CsplTable as Table } from "../../../../components";
import AddToolTip from "../../../../components/AddToolTip";

const columns = [
  {
    label: "Classification type",
    className: "column-classificationType",
    columnName: "classificationTypeName",
    link: `link`,
  },
  {
    label: "Classification code",
    className: "column-classificationCode",
    columnName: "code",
  },
  // {
  //     label: "Classification name",
  //     className: "column-classificationName",
  //     columnName: "classificationName",
  // },
  {
    label: "Classification Start date",
    className: "column-startDate",
    columnName: "effectiveStartDate",
  },
  {
    label: "Classification End date",
    className: "column-endDate",
    columnName: "effectiveEndDate",
  },
];

export const EmployeeClassificationTable = ({ data }) => {
  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center">
          <div className="plan-sub-heading">
            Employee Classification History
          </div>
        </div>
      </div>
      <Table>
        <Table.Thead>
          <Table.Tr>
            {columns.map((item, index) => {
              return (
                <Table.Th key={index} className={item.className}>
                  {item.label}
                </Table.Th>
              );
            })}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((source, index) => {
            return (
              <Table.Tr key={index}>
                {columns.map((item, cellIndex) => {
                  return (
                    <Table.Td key={cellIndex} className={item.className}>
                      {!isEmpty(item.link) ? (
                        source[item.columnName]?.length > 30 ? (
                          <AddToolTip
                            className="short-desc"
                            name={source[item.columnName] || "-"}
                            placement="bottom"
                          >
                            {source[item.columnName].slice(0, 30) || "-"}
                            ...
                          </AddToolTip>
                        ) : (
                          source[item.columnName] || "-"
                        )
                      ) : item.dataMapper ? (
                        item.dataMapper[source[item.columnName]]
                      ) : item.columnName == "effectiveStartDate" ||
                        item.columnName == "effectiveEndDate" ? (
                        usDateFormat(source[item.columnName])
                      ) : source[item.columnName]?.length > 30 ? (
                        <AddToolTip
                          className="short-desc"
                          name={source[item.columnName] || "-"}
                          placement="bottom"
                        >
                          {source[item.columnName].slice(0, 30) || "-"}
                          ...
                        </AddToolTip>
                      ) : (
                        source[item.columnName] || "-"
                      )}
                    </Table.Td>
                  );
                })}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </>
  );
};
